'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _IconButton = require('../../IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _variables = require('../../style/variables');

var _variables2 = _interopRequireDefault(_variables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var closeBtn = null,
        style = {},
        _state = this.state,
        offsetTop = _state.offsetTop,
        offsetLeft = _state.offsetLeft,
        visible = _state.visible,
        minWidth = _state.minWidth,
        _props = this.props,
        closeAvailable = _props.closeAvailable,
        theme = _props.theme,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        children = _props.children,
        classList = this.compileStyle(_index2.default);


    if (closeAvailable) {
        closeBtn = _react2.default.createElement(_IconButton2.default, {
            icon: theme.appearance,
            className: classList.closeIcon,
            width: _variables2.default.gutter * 3,
            height: _variables2.default.gutter * 3,
            onClick: this._close
        });
    }

    if (offsetTop !== null && offsetLeft !== null) {
        style = {
            transform: 'translateY(' + offsetTop + ') translateX(' + offsetLeft + ')'
        };
    }

    if (visible) {
        style.opacity = 1;
    }

    return _react2.default.createElement(
        'div',
        {
            className: classList.root + ' ' + className,
            style: { minWidth: minWidth },
            ref: this._rootRef
        },
        _react2.default.createElement('div', { className: classList.wrapper, onClick: closeAvailable ? function (e) {
                return _this._close();
            } : null }),
        _react2.default.createElement(
            'div',
            { className: classList.container, ref: this._containerRef, style: style },
            _react2.default.createElement(
                'div',
                null,
                children
            ),
            closeBtn
        )
    );
}